import React from 'react'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Constant from '../../Constant'
import JSZip from 'jszip'
import { saveAs } from 'file-saver'
import Loader from '../../common/Loader'
import Button from '../../common/CustomComponents/Button'

import { Dialog, DialogContent, DialogTitle } from '@material-ui/core'

class GalleryList extends React.Component {
  state = {
    title: '',
    list: [],
    isLoading: false,
    type: this.props.match.params.type,

    selectedId: null,
    isEditing: false,
    isVideoAddDisabled: false,
    disableDownloadAllImages: false,

    openUploadModal: false,
    uploadType: null,
    videoPreview: 'set',
    galleryLargeImage: '',
    galleryLargeImages: [], // For multiple images
    imagePreview: '',
    imagePreviews: [], // For multiple image previews
    isSaving: false,
    order: '',
  }

  componentDidMount() {
    this.setState({
      isLoading: true,
      title:
        this.state.type === 'cruise'
          ? 'Cruise'
          : this.state.type === 'event-company'
            ? 'Event Company'
            : this.state.type === 'event'
              ? 'Event'
              : this.state.type === 'chalet'
                ? 'Chalet'
                : this.state.type === 'car'
                  ? 'Car'
                  : this.state.type === 'addons'
                    ? 'Addons'
                    : '',
    })
    this.fetchGalleryList()
  }

  fetchGalleryList = async () => {
    const url =
      this.state.type === 'cruise'
        ? `/cruise/list-gallery/${this.props.match.params.id}`
        : this.state.type === 'event'
          ? `/cruise/list-event-gallery/${this.props.match.params.id}`
          : this.state.type === 'addons'
            ? `/cruise/list-addons-gallery/${this.props.match.params.id}`
            : this.state.type === 'event-company'
              ? `/event-companies/list-gallery/${this.props.match.params.id}`
              : this.state.type === 'chalet'
                ? `/chalet/list-chalet-gallary/${this.props.match.params.id}`
                : this.state.type === 'car'
                  ? `/car/list-car-gallary/${this.props.match.params.id}`
                  : ''

    await axios
      .get(Constant.getAPI() + url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          const videoFormats = /\.(mp4|avi|mov|wmv|flv)$/i
          // For chalet, check 'img' field, for others check 'gal_img_name'
          const imageField = this.state.type === 'chalet' ? 'img' : this.state.type === 'car' ? 'img' : 'gal_img_name'

          const containsVideo = res.data.data.some((element) => videoFormats.test(element[imageField] || element.img))

          this.setState({
            isLoading: false,
            list: res.data.data,
            isVideoAddDisabled: containsVideo || false,
          })
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  deleteGalleryItem = (id) => {
    this.setState({ isLoading: true })
    const data =
      this.state.type === 'cruise'
        ? {
            cruise_id: this.props.match.params.id,
            gallery_id: id,
          }
        : this.state.type === 'event'
          ? {
              event_id: this.props.match.params.id,
              gallery_id: id,
            }
          : this.state.type === 'addons'
            ? {
                addon_id: this.props.match.params.id,
                gallery_id: id,
              }
            : ''

    const url =
      this.state.type === 'cruise'
        ? `/cruise/delete-cruise-gallery-img`
        : this.state.type === 'event'
          ? `/cruise/delete-event-gallery-img`
          : this.state.type === 'addons'
            ? `/cruise/delete-addons-gallery-img`
            : this.state.type === 'event-company'
              ? `/event-companies/delete-gallery/${id}`
              : this.state.type === 'chalet'
                ? `/chalet/delete-chalet-gallary/${id}`
                : this.state.type === 'car'
                  ? `/car/delete-car-gallary/${id}`
                  : ''

    axios
      .delete(Constant.getAPI() + url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        data,
      })
      .then(() => {
        Swal.fire({
          title: 'Gallery Image/Video Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.fetchGalleryList()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({ isLoading: false })
      })
  }

  handleEdit = (selectedId, order) => {
    this.setState({ isEditing: true, selectedId, order })
  }

  handleSortChange = (selectedId) => {
    this.setState({ isEditing: false })

    const url =
      this.state.type === 'cruise'
        ? `/cruise/gallery-order-change`
        : this.state.type === 'event'
          ? `/cruise/event-gallery-order-change`
          : this.state.type === 'addons'
            ? `/cruise/addons-gallery-order-change`
            : this.state.type === 'event-company'
              ? `/event-companies/event-gallery-order-change`
              : this.state.type === 'chalet'
                ? `/chalet/update-order`
                : this.state.type === 'car'
                  ? `/car/update-order`
                  : ''

    axios
      .post(
        Constant.getAPI() + url,
        {
          id: selectedId,
          order: parseInt(this.state.order),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then(() => {
        this.fetchGalleryList()
      })
      .catch(() => {})
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  downloadAllMedia = async (selectedRows) => {
    this.setState({ disableDownloadAllImages: true })

    const { list } = this.state
    const selectedIndices = selectedRows.map((rowIndex) => rowIndex)
    const selectedItems = selectedIndices.map((i) => list[i])

    // For chalet, use 'img' field, for others use 'gal_large_img'
    const imageField = this.state.type === 'chalet' ? 'img' : this.state.type === 'car' ? 'img' : 'gal_large_img'
    const mediaUrls = selectedItems
      .map((item) => item[imageField] || item.img || item.gal_large_img)
      .filter((url) => typeof url === 'string' && url.length > 0)

    if (mediaUrls.length === 0) {
      Swal.fire({
        title: 'No media selected for download.',
        icon: 'warning',
        confirmButtonText: 'Ok',
      })
      this.setState({ disableDownloadAllImages: false })
      return
    }

    // Use appropriate folder name based on type
    const folderName =
      this.state.type === 'event'
        ? 'Event_media'
        : this.state.type === 'chalet'
          ? 'Chalet_media'
          : this.state.type === 'car'
            ? 'Car_media'
            : 'MediaFiles'

    const zip = new JSZip()
    const folder = zip.folder(folderName)

    const errors = []

    try {
      await Promise.all(
        mediaUrls.map(async (relativePath, idx) => {
          const fullUrl = Constant.getImage() + relativePath

          // Better file extension detection
          const ext = /\.(mp4|mov|avi|wmv|flv)$/i.test(relativePath) ? '.mp4' : '.jpg'
          const fileName =
            this.state.type === 'event'
              ? `Event_media_${idx + 1}${ext}`
              : this.state.type === 'chalet'
                ? `Chalet_media_${idx + 1}${ext}`
                : this.state.type === 'car'
                  ? `Car_media_${idx + 1}${ext}`
                  : `media_${idx + 1}${ext}`

          try {
            const resp = await fetch(fullUrl)
            if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
            const blob = await resp.blob()
            folder.file(fileName, blob)
          } catch (err) {
            console.error(`Failed to fetch ${fullUrl}:`, err)
            errors.push(fullUrl)
          }
        })
      )

      const content = await zip.generateAsync({ type: 'blob' })
      const zipFileName =
        this.state.type === 'event'
          ? `Event_media_${Date.now()}.zip`
          : this.state.type === 'chalet'
            ? `Chalet_media_${Date.now()}.zip`
            : this.state.type === 'car'
              ? `Car_media_${Date.now()}.zip`
              : 'MediaFiles.zip'
      saveAs(content, zipFileName)

      if (errors.length) {
        Swal.fire({
          title: `Downloaded ${mediaUrls.length - errors.length} files, but failed to fetch ${errors.length} file(s)`,
          icon: 'warning',
          confirmButtonText: 'Ok',
        })
      }
    } catch (zipErr) {
      console.error('Error creating zip:', zipErr)
      Swal.fire({
        title: 'An error occurred while generating the ZIP file.',
        icon: 'error',
        confirmButtonText: 'Ok',
      })
    } finally {
      this.setState({ disableDownloadAllImages: false })
    }
  }

  handleChangeImage = (e) => {
    const files = Array.from(e.target.files || [])

    // Validate all files are images
    const invalidFiles = files.filter((file) => file?.type?.startsWith('video/'))
    if (invalidFiles.length > 0) {
      Swal.fire('Invalid image file', 'Please select only image files', 'error')
      this.setState({
        galleryLargeImages: [],
        imagePreviews: [],
      })
      if (this.fileInputRef) this.fileInputRef.value = ''
      return
    }

    // Create previews for all selected images
    const previews = files.map((file) => URL.createObjectURL(file))

    this.setState({
      galleryLargeImages: files,
      galleryLargeImage: files[0] || '', // Keep for backward compatibility
      imagePreviews: previews,
      imagePreview: previews[0] || '', // Keep for backward compatibility
      videoPreview: null,
    })
  }

  handleChangeVideo = (e) => {
    this.setState({ [e.target.name]: e.target.files[0] })
    if (e.target.files[0]?.type?.startsWith('image/')) {
      Swal.fire('Invalid video file', '', 'error')
      this.setState({ galleryLargeImage: null })
      return
    } else {
      this.setState({ videoPreview: URL.createObjectURL(e.target.files?.[0]), imagePreview: null })
    }
  }

  handleSave = () => {
    const formData = new FormData()
    const url =
      this.state.type === 'cruise'
        ? `/cruise/add-cruise-gallery`
        : this.state.type === 'event'
          ? `/cruise/add-event-gallery`
          : this.state.type === 'addons'
            ? `/cruise/add-addons-gallery`
            : this.state.type === 'event-company'
              ? `/event-companies/add-gallery`
              : this.state.type === 'chalet'
                ? `/chalet/add-chalet-image`
                : this.state.type === 'car'
                  ? `/car/add-car-image`
                  : ''

    if (this.state.type === 'cruise') {
      formData.append('cruise_id', this.props.match.params.id)
      formData.append('image_type', this.state.type || 'cruise')
    } else if (this.state.type === 'event-company') {
      formData.append('company_id', this.props.match.params.id)
    } else if (this.state.type === 'event') {
      formData.append('event_id', this.props.match.params.id)
    } else if (this.state.type === 'addons') {
      formData.append('addon_id', this.props.match.params.id)
    } else if (this.state.type === 'chalet') {
      formData.append('chalet_id', this.props.match.params.id)
    } else if (this.state.type === 'car') {
      formData.append('car_id', this.props.match.params.id)
    }

    // For chalet, use 'img' field, for others use 'gal_large_img'
    const fileFieldName = this.state.type === 'chalet' ? 'img' : this.state.type === 'car' ? 'img' : 'gal_large_img'

    // If multiple images are selected, append all of them
    if (this.state.uploadType === 'image' && this.state.galleryLargeImages.length > 0) {
      this.state.galleryLargeImages.forEach((file) => {
        formData.append(fileFieldName, file)
      })
    } else {
      // Single file upload (for video or backward compatibility)
      formData.append(fileFieldName, this.state.galleryLargeImage)
    }

    this.setState({ isSaving: true })

    axios
      .post(Constant.getAPI() + url, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        // Clean up object URLs to prevent memory leaks
        this.state.imagePreviews.forEach((preview) => {
          if (preview) URL.revokeObjectURL(preview)
        })

        // Store upload type and count from response before resetting state
        const uploadType = this.state.uploadType
        const responseData = res.data?.data
        const itemCount = Array.isArray(responseData) ? responseData.length : 1

        this.setState({
          isSaving: false,
          openUploadModal: false,
          galleryLargeImage: '',
          galleryLargeImages: [],
          imagePreview: '',
          imagePreviews: [],
          videoPreview: 'set',
        })
        if (res.status) {
          // Determine the success message based on upload type
          let successMessage = ''
          if (uploadType === 'video') {
            successMessage = 'Video Added Successfully!'
          } else {
            successMessage = `${itemCount} ${itemCount > 1 ? 'Images' : 'Image'} Added Successfully!`
          }

          Swal.fire({
            title: successMessage,
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          if (this.fileInputRef) this.fileInputRef.value = ''
        }
        this.fetchGalleryList()
      })
      .catch((err) => {
        // Clean up object URLs on error
        this.state.imagePreviews.forEach((preview) => {
          if (preview) URL.revokeObjectURL(preview)
        })

        this.setState({ isSaving: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            showConfirmButton: false,
            timer: 2500,
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: this.state.type === 'chalet' ? 'thumb_img' : this.state.type === 'car' ? 'thumb_img' : 'gal_thumb_img',
        label: 'Thumb Image/Video',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (cruise_thumb_img) => {
            return (
              <div>
                {cruise_thumb_img?.indexOf('.mp4') === -1 ? (
                  <img
                    src={cruise_thumb_img ? Constant.getImage() + cruise_thumb_img : './assets/images/icon.png'}
                    className="img-fluid"
                    style={{ height: 50 }}
                    alt="tbl"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                ) : (
                  <video
                    width="250"
                    controls
                  >
                    <source
                      src={cruise_thumb_img ? Constant.getImage() + cruise_thumb_img : './assets/images/icon.png'}
                      type="video/mp4"
                    />
                  </video>
                )}
              </div>
            )
          },
        },
      },
      {
        name: this.state.type === 'chalet' ? 'img' : this.state.type === 'car' ? 'img' : 'gal_large_img',
        label: 'Image/Video',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (gal_large_img) => {
            return (
              <div>
                {gal_large_img !== null && gal_large_img !== undefined ? (
                  <div>
                    {gal_large_img?.indexOf('.mp4') !== -1 ? (
                      <video
                        width="150"
                        height="100"
                        controls
                      >
                        <source
                          src={
                            gal_large_img !== undefined && gal_large_img !== null
                              ? Constant.getImage() + gal_large_img
                              : './assets/images/icon.png'
                          }
                          type="video/mp4"
                        />
                      </video>
                    ) : (
                      <img
                        src={
                          gal_large_img !== undefined && gal_large_img !== null
                            ? Constant.getImage() + gal_large_img
                            : './assets/images/icon.png'
                        }
                        className="img-fluid"
                        style={{ height: 50 }}
                        alt="tbl"
                        onError={(event) => {
                          event.currentTarget.src = './assets/images/no_image.png'
                        }}
                      />
                    )}
                  </div>
                ) : (
                  <img
                    src={
                      gal_large_img !== undefined && gal_large_img !== null
                        ? Constant.getImage() + gal_large_img
                        : './assets/images/icon.png'
                    }
                    className="img-fluid"
                    style={{ height: 50 }}
                    alt="tbl"
                    onError={(event) => {
                      event.currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'gal_img_name',
        label: `Name`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            // Find id column - it's always the last column in the rowData
            // Columns order: gal_thumb_img, gal_large_img, gal_img_name (optional), order, id
            var id = tableMeta.rowData[tableMeta.rowData.length - 1]
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {this.state.isEditing ? (
                      this.state.selectedId === id ? (
                        <input
                          type="text"
                          name="order"
                          className="form-control px-1 form-control-sm"
                          style={{ width: '50px' }}
                          onChange={this.handleInputChange}
                          value={this.state.order}
                        />
                      ) : (
                        <div
                          className="form-control"
                          style={{ width: '50px' }}
                        >
                          {order}
                        </div>
                      )
                    ) : (
                      <div
                        className="form-control"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {this.state.isEditing ? (
                        this.state.selectedId === id ? (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.handleSortChange.bind(this, id)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                          </span>
                        ) : (
                          <span
                            className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                            onClick={this.handleEdit.bind(this, id, order)}
                          >
                            <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                          </span>
                        )
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center   shadow-sm"
                          onClick={this.handleEdit.bind(this, id, order)}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <span
                  onClick={this.deleteGalleryItem.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      filter: false,
      search: false,
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: true,
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Products Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
      customToolbarSelect: (selectedRows) => {
        return (
          <Button
            startIcon={
              this.state.disableDownloadAllImages ? (
                <i className="icofont icofont-spin icofont-refresh"></i>
              ) : (
                <i className="icofont icofont-download-alt"></i>
              )
            }
            disabled={this.state.disableDownloadAllImages}
            onClick={() => {
              const selectedIndices = selectedRows.data.map((row) => row.index)
              this.downloadAllMedia(selectedIndices)
            }}
          >
            {this.state.disableDownloadAllImages ? 'Downloading...' : 'Download All Image/Video'}
          </Button>
        )
      },
    }

    return (
      <div className="pcoded-inner-content">
        {this.state?.isLoading && (
          <Loader
            open={this.state?.isLoading}
            fullPage={true}
          />
        )}
        <Dialog
          open={this.state.openUploadModal}
          fullWidth
          maxWidth="lg"
          onBackdropClick={() => {
            // Clean up object URLs
            this.state.imagePreviews.forEach((preview) => {
              if (preview) URL.revokeObjectURL(preview)
            })

            this.setState({
              openUploadModal: false,
              galleryLargeImage: '',
              galleryLargeImages: [],
              imagePreview: '',
              imagePreviews: [],
              videoPreview: 'set',
            })
          }}
        >
          <DialogTitle>{this.state.uploadType === 'video' ? 'Add Video' : 'Add Image(s)'}</DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="col-12 m-b-10">
                {this.state.videoPreview !== 'set' ? (
                  <div>
                    {this.state.videoPreview !== null ? (
                      <video
                        width="250"
                        controls
                      >
                        <source
                          src={this.state.videoPreview ?? './assets/images/icon.png'}
                          type="video/mp4"
                        />
                      </video>
                    ) : this.state.imagePreviews.length > 0 ? (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                        {this.state.imagePreviews.map((preview, index) => (
                          <img
                            key={index}
                            width="150px"
                            height="150px"
                            src={preview}
                            alt={`Preview ${index + 1}`}
                            style={{ objectFit: 'cover', border: '1px solid #ddd', borderRadius: '4px' }}
                          />
                        ))}
                      </div>
                    ) : (
                      <img
                        width="150px"
                        src={this.state.imagePreview ?? './assets/images/icon.png'}
                        alt="img"
                      />
                    )}
                  </div>
                ) : (
                  <img
                    width="150px"
                    src={'./assets/images/no_image.png'}
                    alt="img"
                    onError={({ currentTarget }) => {
                      currentTarget.src = './assets/images/no_image.png'
                    }}
                  />
                )}
              </div>
              <div className="col-3">{this.state.uploadType === 'video' ? 'Video(MP4)' : 'Image(s)'}</div>
              <div className="col-5">
                <div className="form-group">
                  {this.state.uploadType === 'image' ? (
                    <input
                      ref={(ref) => (this.fileInputRef = ref)}
                      type="file"
                      id="img"
                      name="galleryLargeImage"
                      accept="image/*"
                      multiple
                      className="w-100"
                      onChange={this.handleChangeImage}
                    />
                  ) : (
                    <input
                      ref={(ref) => (this.fileInputRef = ref)}
                      type="file"
                      id="img"
                      name="galleryLargeImage"
                      accept=".mp4"
                      className="w-100"
                      onChange={this.handleChangeVideo}
                    />
                  )}
                </div>
                {this.state.uploadType === 'image' && this.state.galleryLargeImages.length > 0 && (
                  <div className="mt-2">
                    <small className="text-muted">
                      {this.state.galleryLargeImages.length} image{this.state.galleryLargeImages.length > 1 ? 's' : ''}{' '}
                      selected
                    </small>
                  </div>
                )}
              </div>
              <div className="col-4">
                <div className="row">
                  <div className="text-right col-6 offset-6">
                    <Button
                      disabled={
                        this.state.isSaving ||
                        (this.state.uploadType === 'image'
                          ? this.state.galleryLargeImages.length === 0
                          : !this.state.galleryLargeImage)
                      }
                      startIcon={<i className="ti-save"></i>}
                      onClick={this.handleSave}
                    >
                      {this.state.isSaving ? 'Saving...!' : 'Save'}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </DialogContent>
        </Dialog>
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-12">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>{this.state.title} Gallery List</h4>
                    </div>
                  </div>
                  <Button
                    onClick={() =>
                      this.setState({
                        openUploadModal: true,
                        uploadType: 'image',
                        galleryLargeImage: '',
                        galleryLargeImages: [],
                        imagePreview: '',
                        imagePreviews: [],
                        videoPreview: 'set',
                      })
                    }
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger ml-2"
                  >
                    <i className="icofont icofont-plus m-r-5"></i>
                    Add Image
                  </Button>
                  <Button
                    onClick={() =>
                      this.setState({
                        openUploadModal: true,
                        uploadType: 'video',
                        galleryLargeImage: '',
                        galleryLargeImages: [],
                        imagePreview: '',
                        imagePreviews: [],
                        videoPreview: 'set',
                      })
                    }
                    className={`btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger ${this.state.isVideoAddDisabled ? 'disabled-button' : ''}`}
                    disabled={this.state.isVideoAddDisabled}
                  >
                    <i className="icofont icofont-plus m-r-5"></i>
                    Add Video
                  </Button>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="dt-responsive table-responsive">
                    <MUIDataTable
                      className="table-responsive"
                      data={this.state.list}
                      columns={columns}
                      options={options}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default GalleryList
